module.exports = __webpack_public_path__ + "img/Dantam Fashion 02.f524d40b.jpg";